export default "__VITE_ASSET__CNr0wyPL__"